import { React, Fragment, memo, useContext } from 'react'
import { Divider, Col, Row, Checkbox, BodyText } from '@paypalcorp/pp-react'
import { string, array, func } from 'prop-types'

import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react'
import { MessageFormat } from '@paypalcorp/worldready'

import DARInfo from './request-info'

const DARSection = memo((props) => {
  const { category, value, infos, desc, onSectionClick, selectedInfos } = props
  const worldReady = useContext(WorldReadyContext)

  return (
    <Fragment>
      {Object.keys(infos).length > 0 && (
        <Fragment>
          <Row className="requestForm-section-row">
            <Col>
              <Row>
                <Col>
                  <BodyText strong>
                    <Message id={category} />
                  </BodyText>
                </Col>
              </Row>
              <Row className="requestForm-section-desc">
                <Col>
                  <Message id={desc} />
                </Col>
              </Row>
              {infos.map((info, index) => {
                return info.countryFeatureEnabled ? (
                  <DARInfo
                    key={index}
                    {...info}
                    onSectionClick={onSectionClick}
                    selectedInfos={selectedInfos}
                  />
                ) : null
              })}
            </Col>
          </Row>
          <Divider secondary theme="v2" />
        </Fragment>
      )}
      {Object.keys(infos).length === 0 && (
        <Row className="requestForm-section-row" id={'request_usage_info'}>
          <Col xs={10} md={11}>
            <Row>
              <Col>
                <BodyText strong>
                  <Message id={category} />
                </BodyText>
              </Col>
            </Row>
            <Row className="requestForm-section-desc">
              <Col>
                <BodyText>
                  <Message id={desc} />
                </BodyText>
              </Col>
            </Row>
          </Col>
          <Col xs={1} md={1}>
            <Checkbox
              id="chk-request_usage_info"
              theme="v2"
              name="infooption"
              aria-label={new MessageFormat(worldReady, {
                id: category,
              }).format()}
              value={value}
              checked={selectedInfos && selectedInfos.includes(value)}
              onChange={onSectionClick}
            />
          </Col>
        </Row>
      )}
    </Fragment>
  )
})

DARSection.propTypes = {
  value: string,
  category: string,
  desc: string,
  infos: array,
  onSectionClick: func.isRequired,
}

DARSection.displayName = 'DARSection'

export default DARSection
